import type { ImageAspectRatio } from './Image.types'

export const aspectRatioValues: Record<ImageAspectRatio, number | 'auto'> = {
  '1:1': 1,
  '1:2': 0.5,
  '2:1': 2,
  '2:3': 2 / 3,
  '3:2': 3 / 2,
  '3:4': 3 / 4,
  '4:3': 4 / 3,
  '9:16': 9 / 16,
  '9:21': 9 / 21,
  '16:9': 16 / 9,
  '21:9': 21 / 9,
  'golden-ratio-landscape': (1 + Math.sqrt(5)) / 2, // ~1.618
  'golden-ratio-portrait': 2 / (1 + Math.sqrt(5)), // ~0.618
  'a4-landscape': Math.sqrt(2), // ~1.414
  'a4-portrait': 1 / Math.sqrt(2), // ~0.707
  'flexible': 'auto', // no fixed aspect ratio, requires setting a height for the container
}
